module.exports = __webpack_public_path__ + "static/media/Caret.dd15a82b.svg";